const jobsAccordion = () => {
	$(".resumator-job-view-details").on("click", function (){
		$(".resumator-job-view-details").addClass("active");
	});
}

export default jobsAccordion;



// WEBPACK FOOTER //
// ./scripts/modules/jobs-toggle.js